import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { DEFAULT_DISPLAY_LANGUAGE } from '../../shared/locale/locale.mjs';
import { LanguageSwitch } from './LanguageSwitch';

export function Subprocessors(): JSX.Element {
  const { t, i18n } = useTranslation('subprocessors');
  // A translation is shown with a note that the English page governs (i18n spec §7 decision 9).
  const translated = i18n.language !== DEFAULT_DISPLAY_LANGUAGE;
  return <main style={{ maxWidth: 760, margin: '3rem auto', padding: '0 24px', position: 'relative' }}>
    <div className="lx-corner-tools"><LanguageSwitch className="cp-theme-button" /></div>
    <Typography.Title level={1}>{t('title')}</Typography.Title>
    {translated && <Alert type="info" showIcon message={t('translationNote')} style={{ marginBottom: 16 }} />}
    <Typography.Paragraph>{t('intro')}</Typography.Paragraph>
    <Typography.Title level={2}>{t('intake.title')}</Typography.Title>
    <Typography.Paragraph>{t('intake.routing')}</Typography.Paragraph>
    <Typography.Paragraph>{t('intake.records')}</Typography.Paragraph>
    <Typography.Title level={2}>{t('china.title')}</Typography.Title>
    <Typography.Paragraph>{t('china.cloudfront')}</Typography.Paragraph>
    <Typography.Paragraph>{t('china.daemons')}</Typography.Paragraph>
    <Typography.Title level={2}>{t('relay.title')}</Typography.Title>
    <Typography.Paragraph>{t('relay.lambda')}</Typography.Paragraph>
    <Typography.Link href="/">{t('back')}</Typography.Link>
  </main>;
}
